declare module 'react-delegate-component';